// import React from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css'; 
// import navlogo from '../Assets/nav-logo.png';

// const Navbar = () => {
//   return (
//     <nav className="mb-1 shadow-sm navbar navbar-expand-lg bg-gradient-to-l from-blue-800 via-blue-200 to-blue-800" style={{ maxHeight: '100px' }}>
//       <div className="container d-flex justify-content-center align-items-center">
//         <a href="/admin" className="navbar-brand d-flex align-items-center">
//           <img src={navlogo} className="img-fluid" style={{ width: '100px' }} alt="Logo" />
//         </a>
//       </div>
//     </nav>
//   );
// }

// export default Navbar;
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import navlogo from "../Assets/nav-logo.png";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [showPopup, setShowPopup] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("token");

    setShowPopup(true);

    // close popup & redirect
    setTimeout(() => {
      setShowPopup(false);
      navigate("/");
    }, 2000);
  };

  // hide logout button on login page
  const onLoginPage = location.pathname === "/";

  return (
    <>
      {/* NAVBAR */}
      <nav className="shadow-sm navbar navbar-expand-lg bg-gradient-to-l from-blue-800 via-blue-200 to-blue-800">
        <div className="container">

          <div className="d-flex align-items-center">
            <img
              src={navlogo}
              className="img-fluid"
              style={{ width: "60px", marginRight: "10px" }}
              alt="Logo"
            />
            <span style={{ fontSize: "20px", fontWeight: "600", color: "white" }}>
              Admin Panel
            </span>
          </div>

          {!onLoginPage && (
            <button
              onClick={handleLogout}
              className="ms-auto"
              style={{
                background: "black",
                color: "white",
                padding: "8px 18px",
                borderRadius: "6px",
                border: "none",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Logout
            </button>
          )}
        </div>
      </nav>

      {/* POPUP MESSAGE */}
      {showPopup && (
        <div style={overlayStyle}>
          <div style={popupStyle}>
            <p>You were logged out</p>
          </div>
        </div>
      )}
    </>
  );
};

// POPUP STYLES
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  height: "100vh",
  width: "100vw",
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const popupStyle = {
  background: "white",
  padding: "20px 40px",
  borderRadius: "10px",
  boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
  fontSize: "18px",
  fontWeight: "600",
};

export default Navbar;
